import styled from 'styled-components/macro';
import Breakpoints from 'themes/constants/breakpoints';
import LazyImg from 'components/Lazy/img/LazyImg';

export const ArticlesCardBasicWrap = styled.div<{ disabled?: boolean }>`
    position: relative;
    display: flex;
    max-width: 100%;
    width: 100%;
    background: ${({ theme }) => theme.background.card.article};
    border-radius: ${({ theme }) => theme.borderRadius.card.article};
    box-shadow: ${({ theme }) => theme.boxShadow.card.article};
    overflow: hidden;
    opacity: ${({ disabled }) => disabled && 0.3};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    @media only screen and (${Breakpoints.LAPTOP}) {
        box-shadow: ${({ theme }) => theme.boxShadow.card.journal};
    }
`;
export const ArticlesCardMainWrap = styled(ArticlesCardBasicWrap)`
    flex-flow: column nowrap;
    padding: ${({ theme }) => theme.paddings.inner.card.padding};
`;
export const ArticlesCardBasicImg = styled(LazyImg)`
    background: ${({ theme }) => theme.background.skeleton};
`;
export const ArticlesCardImgMainWrap = styled.div`
    position: relative;
    border-radius: ${({ theme }) => theme.borderRadius.card.article};
    margin-bottom: 12px;
    height: 0;
    overflow: hidden;
    padding-bottom: calc(100% - 60px);
    @media only screen and (${Breakpoints.LAPTOP}) {
        padding-bottom: calc(100% - 80px);
    }
`;
export const ArticlesCardImgMain = styled(ArticlesCardBasicImg)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
export const ArticlesCardImgMainSlider = styled(ArticlesCardBasicImg)`
    border-radius: ${({ theme }) => theme.borderRadius.card.article};
    margin-bottom: 5px;
    object-fit: cover;
    height: calc(100% - 80px);
    min-height: calc(100% - 80px);
    @media only screen and (${Breakpoints.TABLET}) {
        height: calc(100% - 100px);
        min-height: calc(100% - 100px);
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        height: calc(100% - 65px);
        min-height: calc(100% - 65px);
    }
`;
export const ArticlesCardBasicCover = styled.div`
    display: flex;
    flex-flow: column nowrap;
    padding: 0 6px;
    color: ${({ theme }) => theme.palette.black};
`;
export const ArticlesCardCoverMain = styled(ArticlesCardBasicCover)``;
export const ArticlesCardBasicPublishedDate = styled.span`
    font-size: 12px;
    line-height: 1.4;
    color: ${({ theme }) => theme.palette.greyDark};
`;
export const ArticlesCardBasicArticleName = styled.span`
    font-size: 12px;
    line-height: 1.2;
    color: ${({ theme }) => theme.palette.secondary};
`;
export const ArticlesCardBasicTitle = styled.span`
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    @media only screen and (${Breakpoints.LAPTOP}) {
        font-size: 14px;
    }
`;
export const ArticlesCardBasicCoverHead = styled.div<{ isTileWithControl?: boolean }>`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    margin: 0 0 6px;
    padding-right: ${({ isTileWithControl }) => (isTileWithControl && '30px')};
    @media only screen and (${Breakpoints.LAPTOP}) {
        align-items: center;
    }
`;
export const ArticlesCardCoverHeadMain = styled(ArticlesCardBasicCoverHead)`
    & > *:not(:last-child) {
        margin-right: 8px;
    }
`;
export const ArticlesCardControlDelete = styled.div<{ disabled?: boolean, isTile?: boolean }>`
    position: absolute;
    top: ${({ isTile }) => (isTile ? '0' : '10px')};
    right: ${({ isTile }) => (isTile ? '0' : '10px')};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    & > span {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: ${({ theme }) => theme.palette.secondary};
        width: 16px;
        height: 16px;
        svg {
            color: ${({ theme }) => theme.palette.white};
            width: 6px;
            height: 6px;
            stroke-width: 5px;
        }
    }
`;
export const ArticlesCardDeletedCover = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: inherit;
    background: ${({ theme }) => theme.background.skeleton};
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    padding: 10px;
    opacity: 0.7;
    z-index: 100;
`;
